<template lang="pug">
  .component-backoffice-category-list.row.column
    .row.column
      base-list(:component="component", :dataLoader="dataLoader", :showPerPageSelect="false")
</template>

<script type="text/babel">
  import KeplerBackofficeSdk from 'src/lib/kepler/backoffice'
  import BaseList from './BaseList'


  export default {
    name: 'TocList',
    components: {
      BaseList,
    },
    data: function () {
      return {
        component: require('src/components/backoffice/ClientType.vue'),
      }
    },
    created() {
    },
    methods: {
      dataLoader(callback) {
        KeplerBackofficeSdk.clientTypes.list().all((data) => {
          var clientTypes = {
            current_page: 1,
            current_page_count: 1,
            items: [],
            items_count: 10,
            page_count: 1,
            per_page_count: 25,
          }

          clientTypes.items = data.clientTypes
          clientTypes.items_count = clientTypes.items.length
          callback(clientTypes)
        })
      },

    },
  }
</script>

<style lang="sass" rel="stylesheet/sass">

</style>



// WEBPACK FOOTER //
// ClientTypeList.vue?5369505c